function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13 1.33v.11A1.68 1.68 0 0011.91.28 39.8 39.8 0 006.67 0a38.17 38.17 0 00-5.22.28A1.7 1.7 0 00.29 1.43 18.09 18.09 0 00.31 8v-.11a1.68 1.68 0 001.13 1.16 39.8 39.8 0 005.22.28 39.88 39.88 0 005.22-.28 1.66 1.66 0 001.17-1.15 17.54 17.54 0 00.27-3.1v-.26A17.91 17.91 0 0013 1.33zM5.34 6.67v-4l3.48 2z"
});

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 13.33 9.33"
  }, props), _ref);
}

export default SvgYoutube;